export function readInitialMaterial(slug) {
    const element = document.getElementById('material-initial-data');
    if (!element) return null;
    try {
        const initial = JSON.parse(element.textContent);
        if (initial.slug !== slug) return null;
        if (initial.material?.slug === slug && typeof initial.material.materialName === 'string') {
            return { slug, material: initial.material, error: null, fromDocument: true };
        }
        if (!initial.material && typeof initial.error === 'string' && initial.error) {
            return { slug, material: null, error: initial.error, fromDocument: true };
        }
    } catch {
        // A missing or malformed bootstrap falls back to the normal JSON API.
    }
    return null;
}
